import styled from 'styled-components';
import { TopCars } from '../HomePage/topCars';
import tw from 'twin.macro';
import { Button } from '../../components/button';
import { useNavigate } from 'react-router-dom';

const PageContainer = styled.div`
  ${tw`flex flex-col w-full max-w-full min-w-0 h-full items-center justify-center box-border`}
`;

const AddCarButtonContainer = styled.div`
  ${tw`absolute top-20 right-4 z-10 w-full max-w-full min-w-0 box-border`}
`;

export default function GuestCarsPage() {
  return (
    <PageContainer>
      <TopCars />
    </PageContainer>
  );
}
